"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.webhookConnectorCreationRequest = exports.WebhookDefaultColumns = void 0;
const tab_1 = require("../tab");
const destination_1 = require("./destination");
const zod_1 = require("zod");
// Auth Config
const WebhookAuthTypes = ['basic', 'oauth', 'none'];
const webhookAuthConfigInput = zod_1.z.discriminatedUnion('type', [
    zod_1.z.object({
        type: zod_1.z.literal('none'),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('basic'),
        user: zod_1.z.string().min(3),
        pass: zod_1.z.string().min(5),
    }),
    zod_1.z.object({
        type: zod_1.z.literal('oauth'),
        jwks_uri: zod_1.z.string().url().min(1),
    }),
]);
exports.WebhookDefaultColumns = [
    {
        id: undefined,
        extractor: '',
        name: '_created_at',
        type: tab_1.ColumnType.DATE,
    },
    {
        id: undefined,
        extractor: '',
        name: '_updated_at',
        type: tab_1.ColumnType.DATE,
    },
    {
        id: undefined,
        extractor: '',
        name: '_errors',
        type: tab_1.ColumnType.STRING, // its a json
    },
];
const webhookSchemaInput = zod_1.z.object({
    id: zod_1.z.number().optional(),
    name: zod_1.z.string().min(1),
    extractor: zod_1.z.string().min(1),
    type: zod_1.z.nativeEnum(tab_1.ColumnType),
});
exports.webhookConnectorCreationRequest = zod_1.z.object({
    schema: webhookSchemaInput.array().min(1),
    auth_config: webhookAuthConfigInput,
    dedupe_requests: zod_1.z.boolean().default(false),
    example_json: zod_1.z.object({}).catchall(zod_1.z.any()).optional(),
    pre_transformers: zod_1.z.string().array().optional(),
    flatten_root: zod_1.z.number().optional(),
    timestamp_getter: zod_1.z.string().optional(),
    destination: zod_1.z.object({
        mode: destination_1.destinationInput,
        destination: destination_1.destinationConfigRequest,
    }),
});
